export { default } from './PostTags';
